<div class="subheader with-padding flgrow">
  <div class="row">
    <div class="col-sm-3">
      <div class="relative flmid">
        <div class="flgrow">
          <div class="input-group">
          <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearch' | translate }}"
            [(ngModel)]="pService.searchTerm" autocomplete="off" />
            <div class="input-group-append">
              <button type="button" class="btn btn-primary">
                <em class="fa fa-search"></em>
              </button>
            </div>
            </div>
        </div>
      </div>
    </div>
    <div class="col-sm-2 pl-4" *ngIf="dealerList && dealerList.length > 1">
      <div class="relative flmid">
        <div class="flgrow">
          <app-dealer-searchbox-dropdown [dealerList]="dealerList"   [selectedDealer]="selectedDealerId"
          ngDefaultControl name="dealerDropdown"
            (onSelectDealer)="onDealerSelected($event)" placeholder="Search Dealer">
          </app-dealer-searchbox-dropdown>
        </div>
      </div>
    </div>
    
    <div class="col-auto ml-auto" *ngIf="userRoleRightsDetails.canAdd">
      <button type="button" (click)="onAdd()" type="reset" aria-label="Center Align" class="add-button btn btn-primary"
        translate>lblAddKeyDropLocation</button>
    </div>
  </div>
</div>
<div class="container prel">
  <div class="row">
    <div class="c12">
      <div class="card mb-3">
        <div class="card-header d-flex" translate>
            lblDealerKeyDrop
        </div>
        <div class="table-responsive">
        <table class="tablest1">
          <thead>
            <tr>
              <th scope="col" style="width: 55px" translate>#</th>
              <th scope="col" sortable="locationName" (sort)="onSort($event)" translate>lblLocationName</th>
              <th scope="col" sortable="dealerName" (sort)="onSort($event)" translate>lblDealerName</th>
              <th scope="col" sortable="locationType" (sort)="onSort($event)" translate>lblLocationType</th>
              <th scope="col" class="text-center" sortable="isActive" (sort)="onSort($event)" translate>lblActive</th>
              <th scope="col" style="width: 120px" class="text-center" translate>lblAction</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="keyDropLocation?.length>0 ; else load_NotFound_Template">
              <tr *ngFor="let item of keyDropLocation; let i=index">
                <td>{{ item.rowNumber }}</td>
                <td>
                  <ngb-highlight [result]="item.locationName" [term]="pService.searchTerm">
                  </ngb-highlight>
                </td>

                <td>
                  <ngb-highlight [result]="item.dealerName" [term]="pService.searchTerm">
                  </ngb-highlight>
                </td>

                <td>
                  <ngb-highlight [result]="item.locationTypeName" [term]="pService.searchTerm">
                  </ngb-highlight>
                </td>

                <td class="text-center">
                    <em class="fas" [ngClass]="{'fa-check': item.isActive, 'fa-close': !item.isActive}"></em>
                </td>

                <td class="nowrap text-center">
                  <a class="btn btn-ico"  ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert" (click)="onEdit(item.id)" *ngIf="userRoleRightsDetails.canEdit">
                    <em class="fas fa-pencil-alt fa-lg"></em>
                  </a>
                  <span class="ico-div" *ngIf="userRoleRightsDetails.canDelete"></span>
                  <a class="btn btn-ico" ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert" (click)="onDelete(item.id)" *ngIf="userRoleRightsDetails.canDelete">
                    <em class="far fa-trash-alt fa-lg"></em>
                  </a>
                  
                  
                </td>

              </tr>
            </ng-container>
            <ng-template #load_NotFound_Template>
              <tr>
                <td colspan="6" class="no-record" translate>lblNoRecordsFound</td>
              </tr>
            </ng-template>
          </tbody>
        </table>
        </div>
        <div class="card-footer">
          <div class="d-flex justify-content-between">
            <div class="d-flex justify-content-between">
              <ngb-pagination [collectionSize]="pService.total$  | async" [(page)]="pService.page"
                [pageSize]="pService.pageSize" [maxSize]="3">
              </ngb-pagination>
              <select class="custom-select mx-2" style="width: auto" name="pageSize" [(ngModel)]="pService.pageSize">
                <option *ngFor="let item of pService.pageItemsArray" [ngValue]="item.values" translate>{{item.label}}
                </option>
              </select>
            </div>
            <div class="d-flex justify-content-between p-2 font17 fontbold" style="margin: auto 0;">
              <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{pService.total$  | async}}&nbsp;<span class="font17 fontnormal" translate>lblResults</span>
            </div>
    
          </div>
        </div>
      </div>
      
    </div>
  </div>

</div>
